import React from 'react'
import { Check } from '../../../assets/icons'
import { Text1Bold } from '../text'
import theme from '../../../styled/theme'
import {
	CheckListContainer,
	CheckListItem,
	CheckListItemContent,
	HiddenCheckbox,
	StyledCheckbox
} from './styled'
import EmptyState from '../../emptyState'

const CheckList = ({
	options = [],
	selectedValues = [],
	onToggle,
	minHeight = '0',
	maxHeight = 'none',
	searchedText = 'vos',
	maxSelected = 3
}) => {
	if (!options.length) {
		return <EmptyState title={`No tenemos resultados para ${searchedText}`} subtitle="Por favor, volvé a intentar con una nueva búsqueda" />
	}

	return (
		<CheckListContainer
			$height={'100%'}
		>
			{options.map(option => {
				const isSelected = selectedValues.includes(option.value)
				const isDisabled = !isSelected && selectedValues.length >= maxSelected

				return (
					<CheckListItem key={option.value}
						$disabled={isDisabled}
						onClick={() => !isDisabled && onToggle && onToggle(option)}>
						<CheckListItemContent>
							<HiddenCheckbox
								checked={isSelected}
								onChange={() => { }}
								onClick={event => event.stopPropagation()}
							/>
							<StyledCheckbox $checked={isSelected} $disabled={isDisabled}>
								{isSelected && <Check color={theme.colors.brand.white} />}
							</StyledCheckbox>
							<Text1Bold>{option.label}</Text1Bold>
						</CheckListItemContent>
					</CheckListItem>
				)
			})}
		</CheckListContainer>
	)
}

export default CheckList